import React from "react";
import { Modal, Button } from "react-bootstrap";
import { useMutation } from "react-query";
import { toast } from "sonner";
import { RemoveBlocklistApi } from "../../Api";
import { useLocation } from "react-router-dom";

interface PropsType {
  show: boolean;
  setShow: (v: boolean) => void;
  number: string;
  handleUnblock: (v: boolean) => void;
}

export default function DeleteBlocklist({
  show,
  setShow,
  number,
  handleUnblock,
}: PropsType) {
  const { state } = useLocation();
  const { mutate, isLoading } = useMutation(RemoveBlocklistApi, {
    mutationKey: "Delete_Block_List",
    onSuccess: (data: any) => {
      setShow(false);
      toast.success(data?.data?.message || "Number added to blocklist");
      handleUnblock(true);
    },
    onError: (data: any) => {
      toast.error(data?.response?.data?.message || "Something wrong.");
    },
  });

  return (
    <Modal show={show} centered onHide={() => setShow(false)} backdrop="static">
      <Modal.Body>
        <div className="form-group mb-3">
          <h5 className="text-center">
            Are you sure you want to unblock this number?
          </h5>
        </div>

        <Modal.Footer className="d-flex justify-content-center border-0">
          <Button
            variant="primary"
            type="button"
            disabled={isLoading}
            style={{ minWidth: 76.5 }}
            onClick={() => mutate({ number, campaign_id: state.id })}
          >
            {isLoading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
                <span className="ps-2">Processing...</span>
              </>
            ) : (
              "Yes"
            )}
          </Button>
          <Button
            style={{ width: 76.5 }}
            variant="secondary"
            onClick={() => {
              setShow(false);
            }}
          >
            No
          </Button>
        </Modal.Footer>
      </Modal.Body>
    </Modal>
  );
}
